<template>
    <inertia-link :href="'/'">
        <svg
            class="z-10 mt-[50px]"
            width="44"
            height="44"
            viewBox="0 0 44 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_308_3627)">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M33.178 0.946644C30.6959 0.378657 26.6158 0 22.0076 0C17.3993 0 13.3155 0.378657 10.8372 0.946644C8.40852 1.45904 6.18095 2.66578 4.42515 4.42024C2.66935 6.17469 1.4609 8.40133 0.946644 10.8296C0.378657 13.3117 0 17.3917 0 22C0 26.6083 0.378657 30.6921 0.946644 33.1704C1.46035 35.5977 2.66767 37.8236 4.42203 39.578C6.17639 41.3323 8.40233 42.5396 10.8296 43.0534C13.3117 43.6213 17.3917 44 22 44C26.6083 44 30.6921 43.6213 33.1704 43.0534C35.5977 42.5396 37.8236 41.3323 39.578 39.578C41.3323 37.8236 42.5396 35.5977 43.0534 33.1704C43.6213 30.6883 44 26.6083 44 22C44 17.3917 43.6213 13.3079 43.0534 10.8296C42.5402 8.40333 41.334 6.17809 39.5811 4.42382C37.8282 2.66956 35.6039 1.46166 33.178 0.946644Z"
                    fill="url(#paint0_linear_308_3627)"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.74805 19.8786C8.42961 20.5601 9.32451 20.9018 10.2175 20.9018C11.1105 20.9018 12.0054 20.5601 12.687 19.8786L19.6046 12.961C20.9677 11.5979 20.9677 9.38516 19.6046 8.02204C18.2414 6.65891 16.0287 6.65891 14.6656 8.02204L7.74805 14.9396C6.38493 16.3027 6.38493 18.5154 7.74805 19.8786ZM10.2175 37.5312C9.32451 37.5312 8.42961 37.1894 7.74805 36.5079C6.38493 35.1448 6.38493 32.9321 7.74805 31.5689L31.2949 8.02204C32.6581 6.65891 34.8708 6.65891 36.2339 8.02204C37.597 9.38516 37.597 11.5979 36.2339 12.961L12.687 36.5079C12.0054 37.1894 11.1105 37.5312 10.2175 37.5312ZM27.503 37.5314C26.6099 37.5314 25.715 37.1896 25.0335 36.5081C23.6704 35.1431 23.6704 32.9322 25.0335 31.5691L31.311 25.2916C32.6741 23.9285 34.8869 23.9266 36.25 25.2916C37.6131 26.6566 37.6131 28.8674 36.25 30.2305L29.9724 36.5081C29.2909 37.1896 28.396 37.5314 27.503 37.5314Z"
                    fill="white"
                />
            </g>
            <defs>
                <linearGradient
                    id="paint0_linear_308_3627"
                    x1="4.77824"
                    y1="4.40102"
                    x2="38.3517"
                    y2="40.6151"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#FF8D47" />
                    <stop offset="0.147634" stop-color="#FF7447" />
                    <stop offset="0.454086" stop-color="#FF4247" />
                    <stop offset="0.636926" stop-color="#E92A5B" />
                    <stop offset="0.740367" stop-color="#DD1C67" />
                    <stop offset="0.842991" stop-color="#D31071" />
                    <stop offset="1" stop-color="#CF0283" />
                </linearGradient>
                <clipPath id="clip0_308_3627">
                    <rect width="44" height="44" rx="11" fill="white" />
                </clipPath>
            </defs>
        </svg>
    </inertia-link>
</template>
